import * as angular from 'angular';

export class UsersFactory {
    private apiRoot: string = '/api/v1/users';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    verifyEmailPassword(value) {
        return this.$http.post(
            `${this.apiRoot}/verify-email-password/`,
            value
        );
    }

    verifyEmail(value) {
        return this.$http.post(
            `${this.apiRoot}/verify-email/`,
            value
        );
    }
}

angular
    .module('app')
    .service('UsersFactory', UsersFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/users.factory.ts